<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('campaigns.campaign_report')">
        <template v-slot:toolbar>
          <b-button size="sm"><i class="fa fa-file-excel pr-5"></i>Excel'e Aktar</b-button>
        </template>
        <template v-slot:preview>
          <div class="row">
            <div class="col-md-3">
              <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Toplam Mesaj</span>
                  <a class="text-muted text-hover-primary">1858</a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Onaylı</span>
                  <span class="text-muted">0</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Reddedilen</span>
                  <span class="text-muted">0</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Onay Bekleyen</span>
                  <span class="text-muted">1858</span>
                </div>
              </div>
            </div>
            <div class="col-md-3"  style="border-left: 1px solid #e5e5e5">
              <div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Tekil Katılım</span>
                  <a class="text-muted text-hover-primary">1855</a>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Tekil Onaylı Katılım</span>
                  <span class="text-muted">0</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Puan Yüklenmiş Mesaj</span>
                  <span class="text-muted">0</span>
                </div>
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <span class="font-weight-bold mr-2">Yüklenmiş Puan</span>
                  <span class="text-muted">0</span>
                </div>
              </div>
            </div>
            <div class="col-md-6" style="border-left: 1px solid #e5e5e5">
              <div class="row">

                <div class="col-md-3">
                  <b-form-group>
                    <b-form-checkbox
                        unchecked-value="not_accepted"
                        class="mb-5"
                    >
                      Sadece Onaylı Olanlara Yükle
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                        unchecked-value="not_accepted"
                        class="mb-5"
                    >
                      Sadece Tekil Katılıma Yükle
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group>
                    <b-form-checkbox
                        unchecked-value="not_accepted"
                        class="mb-5"
                    >
                      Mail Gönder
                    </b-form-checkbox>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Yüklenecek Puan" size="sm">
                    <b-form-input
                        class="form-control form-control-solid"
                        type="number"
                        value="50"
                    ></b-form-input>
                  </b-form-group>
                  <button size="sm" v-on:click="loadPoint" class="btn btn-primary font-weight-bold text-uppercase ">Yükle</button>
                </div>
                <div class="col-md-3">

                </div>
              </div>
            </div>
          </div>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

export default {
  name: "ReportMessageShareCampaign",
  components: { DataTable, DashboardBox },
  methods: {
    loadPoint(){
      Swal.fire({
        title: "",
        text: "Puanlar başarıyla yüklendi!",
        icon: "success",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Tamam",
      });
    },
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {

      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'id', label: '#', sortable: true},
          {key: 'name', label: 'Adı', sortable: true},
          {key: 'surname', label: 'Soyadı', sortable: true},
          {key: 'email', label: 'E-Posta', sortable: true},
          {key: 'register_date', label: 'Katılım Tarihi', sortable: true},
          {key: 'user_image', label: 'Resim', sortable: true},
          {key: 'gsm', label: 'GSM', sortable: true},
          {key: 'status_id', label: 'Üye Durumu', sortable: true},
          {key: 'email_status', label: 'E-Posta Durumu', sortable: true},
          {key: 'parent_id', label: 'Parent ID', sortable: true},
        ],
      },
      table : {
        items : [
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
          {'id' : '3871304', 'name' : 'Neslihan', 'surname' : 'Bilgin', 'email' : 'neslihan.bilgin@dorinsight.com', 'register_date' : '27.12.2020', 'user_image' : '', 'gsm' : '5554443322', 'status_id' : 'Aktif', 'email_status' : 'CNF', 'parent_id' : '' },
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('offers.offers'), route: "offers" },
      { title: this.$t('campaigns.campaign_report') }
    ]);
  }
}
</script>

<style scoped>
</style>
